import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Select } from "antd";
import LazyLoadSelect from "./LazyLoadSelect";
const VehicleSelect = ({ tenantId, disabled = false, value, style, allowClear, onChange, onVehicleSelected }) => {
    const optionsRenderer = (vehicles) => {
        const groupedVehicles = [];
        let currentTypeDescription = null;
        let currentGroup;
        // Assumes `vehicles` is ordered by `vehicleTypeDescription`
        vehicles.map(vehicle => {
            if (vehicle.type.description !== currentTypeDescription) {
                currentTypeDescription = vehicle.type.description;
                currentGroup = {
                    label: currentTypeDescription,
                    vehicles: []
                };
                groupedVehicles.push(currentGroup);
            }
            currentGroup.vehicles.push(vehicle);
        });
        return groupedVehicles.map(vehicleGroup => {
            const groupOptions = vehicleGroup.vehicles.map(vehicle => {
                return (_jsx(Select.Option, { value: vehicle.id, filter: vehicle.registration, children: _jsxs("span", { children: [_jsx("b", { style: {
                                    fontFamily: '"Courier New", Courier, monospace',
                                    fontSize: '120%',
                                    letterSpacing: '1px'
                                }, children: vehicle.registration }), " - ", vehicle.description] }) }, vehicle.id));
            });
            return (_jsx(Select.OptGroup, { label: vehicleGroup.label, children: groupOptions }, vehicleGroup.label));
        });
    };
    return (_jsx(LazyLoadSelect, { url: "/admin/v1/vehicles", tenantId: tenantId, disabled: disabled, allowClear: allowClear, style: style, value: value, placeholder: "Select a vehicle", notFoundMessage: "No vehicles found", searchKey: "registrationLike", queryParams: {
            summary: true,
            active: true,
            orderBy: ['VEHICLE_TYPE_CATEGORY_ASC', 'VEHICLE_TYPE_DESCRIPTION_ASC']
        }, onChange: onChange, onSelected: onVehicleSelected, optionsRenderer: optionsRenderer }));
};
export default VehicleSelect;
